import { useState } from "react";
import type * as Y from "yjs";
import { useT } from "@/lib/i18n";
import { useBoardUI } from "../store";
import { NoteBody } from "./NoteCard";

/** Document: long-form text shown as an icon tile; double-click opens a full-screen editor. */
export function DocumentBody({
  id,
  ymap,
  title,
  fg,
}: {
  id: string;
  ymap: Y.Map<unknown>;
  title: string;
  fg: string;
}) {
  const t = useT();
  const editing = useBoardUI((s) => s.editingId === id);
  const [open, setOpen] = useState(false);
  const frag = ymap.get("body") as Y.XmlFragment;
  const show = open || editing;
  return (
    <>
      <div
        className="flex items-center gap-3 px-3 py-3"
        onDoubleClick={(e) => (e.stopPropagation(), setOpen(true))}
      >
        <div className="display flex h-12 w-10 shrink-0 items-center justify-center rounded-[3px] border border-border bg-panel-3 text-[11px]">
          DOC
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate text-[13px] font-semibold">{title || t.cardTypes.document}</div>
          <div className="text-[11px] text-muted">{t.openDocument}</div>
        </div>
      </div>
      {show ? (
        <div
          className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/80 p-4 pt-10"
          onPointerDown={(e) => e.stopPropagation()}
          onClick={() => (setOpen(false), useBoardUI.getState().setEditing(null))}
          role="presentation"
        >
          <div
            className="w-full max-w-3xl rounded-md border border-border bg-panel shadow-panel"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal
          >
            <div className="flex items-center justify-between border-b border-border px-5 py-3">
              <span className="display text-xl">.{title || t.cardTypes.document}</span>
              <button
                type="button"
                onClick={() => (setOpen(false), useBoardUI.getState().setEditing(null))}
                className="text-muted hover:text-text"
              >
                ✕
              </button>
            </div>
            <div
              className="min-h-[60vh] px-5 py-4 text-[15px]"
              onPointerDown={() => useBoardUI.getState().setEditing(id)}
            >
              <NoteBody id={id} fragment={frag} fg={fg} />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
